<template lang="pug">
div
  .tools-bar(v-if="batch")
    el-checkbox(v-model="batchAll", :indeterminate="indeterminate") 全选/全不选
    .pull-right
      el-button(icon="el-icon-check", type="primary", plain, @click="invertBatch" size="small") 反选
      el-button(v-if="isDelete", :disabled="!edit", icon="el-icon-delete", type="danger", plain, @click="deleteBatch" size="small") 删除选中
  FileList(:class="classMap", v-bind="$attrs", :fileList="showList", :hover="false", @download="download", @delete="deleteFile", @preview="preview")
    template(#btns="{ file }")
      .checkbox(v-if="batch")
        el-checkbox(:label="file.fileId", v-model="checkedIds") &nbsp;
      file-light-flag.status-icon(:row="file", @updateLight="updateLight")
</template>
<script>
import { filePreviewV1 } from "@/CommonDP/utils/docPublic";
import FileList from "./index.vue";
import fileLightFlag from "@/CommonDP/components/fileLightFlag";
import { downloadFile, downloadUrltoken } from "@/CommonDP/utils";
import docService from "@/CommonDP/service/doc-service";
import { mapState } from "vuex";
export default {
  components: { FileList, fileLightFlag },
  inheritAttrs: false,
  props: {
    delete: { default: false, type: Boolean },
    prjId: { default: "", type: String },
    fileList: { default: () => [], type: Array },
    batch: { default: false, type: Boolean }
  },
  data() {
    return {
      checkedIds: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    isDelete() {
      return this.delete;
    },
    edit() {
      return this.delete && this.checkedIds.length > 0;
    },
    indeterminate() {
      const { checkedIds, fileList } = this;
      return !!checkedIds.length && fileList.some(({ fileId }) => checkedIds.indexOf(fileId) === -1);
    },
    batchAll: {
      get() {
        const { checkedIds, fileList } = this;
        return fileList.every(({ fileId }) => checkedIds.indexOf(fileId) > -1);
      },
      set(val) {
        const { fileList } = this;
        let checkedIds = [];
        if (val) checkedIds = fileList.map(({ fileId }) => fileId);
        else checkedIds = [];
        this.checkedIds = checkedIds;
      }
    },
    showList() {
      const list = this.fileList || [];
      return list.map((f) => ({
        ...f,
        folderId: f.fileId,
        $url: downloadUrltoken(f.prjId, f.fileId, f.version),
        $delete: this.delete
      }));
    },
    classMap() {
      return { batch: this.batch };
    }
  },
  methods: {
    async updateLight(row, type) {
      let prjId = this.enterpriseId;
      if (row.fileSource === 2) prjId = row.prjId;
      const messageType = type === 1 ? "优先轻量化操作" : "重新轻量化操作";
      await docService.updateLight(prjId, row.fileId, row.version);
      const file = this.fileList.find(({ fileId }) => fileId === row.fileId) || {};
      file.status = "1";
      this.$message.success(`${messageType}成功`);
    },
    invertBatch() {
      const { fileList, checkedIds } = this;
      this.checkedIds = fileList.filter(({ fileId }) => checkedIds.indexOf(fileId) === -1).map(({ fileId }) => fileId);
    },
    download({ $url }) {
      downloadFile($url);
    },
    preview(file) {
      filePreviewV1({ fileId: file.fileId, parentId: file.parentId, versionId: file.fileVersion || 1, fileType: file.fileType, status: file.status });
    },
    async deleteBatch() {
      const { fileList, checkedIds } = this;
      const surplus = fileList.filter(({ fileId }) => checkedIds.indexOf(fileId) === -1);
      await this.$confirm("确定删除?", "警告");
      const lostList = fileList.splice(0, fileList.length, ...surplus);
      this.checkedIds = [];
      for (const file of lostList) {
        this.$emit("delete", file);
      }
    },
    async deleteFile(file, list) {
      const index = list.indexOf(file);
      await this.$confirm("确定删除?", "警告");
      this.fileList.splice(index, 1);
      this.$emit("delete", this.fileList[index]);
    }
  }
};
</script>
<style lang="scss" scoped>
.checkbox {
  position: absolute;
  left: 8px;
}
.batch /deep/ .file-item {
  padding-left: 32px;
}
.pull-right {
  float: right;
}
.tools-bar {
  position: relative;
  padding: 4px 4px 4px 20px;
}
.status-icon {
  position: relative;
  right: 8px;
}
</style>
